import type { AuraChart } from './AuraChartModel';

export interface AuraVisualizationChart extends AuraChart {
    status: 'complete' | 'partial' | 'unavailable' | 'error';
}

export interface AuraVisualizationPlan {
    status: 'complete' | 'partial' | 'unavailable' | 'error';
    title?: string;
    layout?: 'dashboard';
    charts: AuraVisualizationChart[];
}
